<template>
  <div class="Wdgt-Content-Opinion-Img" ref="parent">
    <template v-for="(image, index) in props.post.images_list">
      <img class="Wdgt-Content__image" @click="openSliderOpinion(index)" :v-lazy="image" />
    </template>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount, nextTick, onMounted } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { initLazyLoadObserver } from '@shared/utils/images/lazyLoad.js';
  import { sliderImagesGroupDisplay } from '@/Groups/Slider/public/utils/callSlider.js';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //-----------------------------
  const store = useStore();
  const props = defineProps(Props());
  //-----------------------------
  const parent = ref(null);
  //-----------------------------
  onMounted(() => {
    initLazyLoadObserver(parent.value);
  })
  //-----------------------------
  //Открыть слайдер с нужным индексом
  const openSliderOpinion = (index) => {
    sliderImagesGroupDisplay(prepareData(), index);
  }
  //Подготовить данные для открытия картинок мнения в слайдере 
  const prepareData = () => {
    const slides = [];
    props.post.images_list.forEach((image) => {
      slides.push({
        url: image,
        caption: null,
      });
    })
    return slides;
  }
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>